<template>
  <div class="content-container">
    <!-- Lewy panel: filtry do bieżących pomiarów -->
    <filters-current-measurement />

    <div class="content-wrap">
      <!-- Komponent główny: obsługa kroków i widoków bieżącego pomiaru -->
      <CurrentMeasurement />
    </div>
  </div>
</template>

<script>
// Importy Pinia, komponentów i stores
import { useCurrentStore } from "@/stores/current";
import CurrentMeasurement from "../components/CurrentMeasurement.vue";
import FiltersCurrentMeasurement from "@/components/FiltersCurrentMeasurement.vue";
import { useVmsStore } from "@/stores/vms";
import { useUserStore } from "@/stores/user.store";

export default {
  name: "HomeView",
  components: {
    CurrentMeasurement,
    FiltersCurrentMeasurement,
  },
  setup() {
    // Store do obsługi stanu bieżącego kroku (krok, widok, itp.)
    const current = useCurrentStore();
    const userStore = useUserStore();

    // Jeśli użytkownik ma dostęp do VMS, ładujemy dane VMS
    if (userStore.hasAccess('Vms')) {
      const vmsStore = useVmsStore();
      if (!vmsStore.isLoaded) {
        vmsStore.loadData();
      }
    }
    
    return {
      current,
    };
  },
  data() {
    return {
      // step: this.current.step, // aktualny krok
      isResult: this.current.isResult // czy jesteśmy na kroku z wynikami
    };
  },
  created() {
    // Obserwuj zmianę kroku w store, synchronizuj ze swoim stanem lokalnym
    // this.$watch(
    //   () => this.current.step,
    //   () => {
    //     this.getCurrentStep();
    //   }
    // );
  },
  methods: {
    // Aktualizuj lokalny krok (np. po zmianie w store)
    // getCurrentStep() {
    //   this.step = this.current.step;
    // },
    // // Przejdź do kolejnego kroku (wywołuje logikę store)
    // nextStep() {
    //   this.step = this.current.nextStep();
    // },
    // // Wróć do poprzedniego kroku (wywołuje logikę store)
    // previousStep() {
    //   this.step = this.current.previousStep();
    // },
  },
};
</script>

<style scoped>
/* Kontener główny z tłem */
.content-container {
  background-color: var(--surface-secondary);
}

/* Ogólne stylowanie przycisków nawigacji */

/* Styl przycisku "Dalej" */
.btn-next {
  margin-right: 50px;
  padding: 8px 40px 8px 8px;
  position: relative;
  color: var(--text-secondary);
}
/* Hover na przycisk "Dalej" */
.btn-next:hover {
  color: var(--text-primary);
}

/* Styl przycisku "Wstecz" */
.btn-prev {
  margin-left: 30px;
  padding: 8px 8px 8px 45px;
  position: relative;
  color: var(--text-secondary);
}
.btn-prev:hover {
  color: var(--text-primary);
}

/* Dół panelu: kontener na przyciski */
.actions-down {
  background-color: var(--surface-primary);
  min-height: 43px;
}

/* Specjalne style tylko dla dolnych przycisków */

/* Stylowanie .btn-next i .btn-prev wewnątrz .actions-down */
.actions-down .btn-next {
  margin-right: 50px;
  padding: 8px 40px 8px 8px;
  position: relative;
  color: var(--text-secondary);
}
.actions-down .btn-next:hover {
  color: var(--text-primary);
}

.actions-down .btn-prev {
  margin-left: 30px;
  padding: 0 0 0 40px;
  position: relative;
  color: var(--text-secondary);
}
.actions-down .btn-prev:hover {
  color: var(--text-primary);
}
</style>
